import { ExperimentStore } from 'bernie-core';

export const isExperimentEnabled = (experimentStore: ExperimentStore, experimentName: string) => {
  return (
    experimentStore &&
    experimentStore.exposures &&
    experimentStore.exposures[experimentName] &&
    experimentStore.exposures[experimentName].bucket > 0
  );
};
